import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TorresCredentials } from '../../../models/torres-credentials.model';
import { CompanyService } from '../../../../services/company.service';
import { TorresService } from '../../../services/torres.service';

@Component({
  selector: 'ag-torres-credentials',
  templateUrl: './torres-credentials.component.html',
  styleUrls: ['./torres-credentials.component.scss']
})
export class TorresCredentialsComponent implements OnInit, OnDestroy {

  @Input() public companyId: number;

  public credentials: TorresCredentials = new TorresCredentials();
  public loading: boolean = true;
  public processing: boolean = false;
  public saved: boolean = false;
  public error: boolean = false;
  public showApiKey: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(
    public companyService: CompanyService,
    private torresService: TorresService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.torresService.get(this.companyId).subscribe({
        next: credentials => {
          if (credentials) this.credentials = credentials;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      })
    );
  }

  public save(form: any): void {
    if (!form.valid) return;

    this.processing = true;
    this.saved = false;
    this.error = false;

    this.subscriptions.push(
      this.torresService.save(this.companyId, this.credentials).subscribe({
        next: credentials => {
          this.credentials = credentials;
          this.processing = false;
          this.saved = true;
        },
        error: () => {
          this.processing = false;
          this.error = true;
        }
      })
    );
  }

  public toggleApiKeyVisibility(): void {
    this.showApiKey = !this.showApiKey;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
